/* MAISON OBSESS V2 — Global JavaScript */
(function () {
  'use strict';

  /* ============================================================
     PAGE LOADER
  ============================================================ */
  window.addEventListener('load', function () {
    var loader = document.getElementById('pageLoader');
    if (loader) {
      setTimeout(function () {
        loader.classList.add('loaded');
      }, 1200);
    }
  });

  /* ============================================================
     CUSTOM CURSOR
  ============================================================ */
  (function initCursor() {
    var dot = document.getElementById('cursorDot');
    var ring = document.getElementById('cursorRing');
    if (!dot || !ring) return;
    if (!window.matchMedia('(hover: hover)').matches) return;

    var mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + (mx - 3) + 'px,' + (my - 3) + 'px)';
    });

    function animateRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.transform = 'translate(' + (rx - 16) + 'px,' + (ry - 16) + 'px)';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a, button, [role="button"]')) {
        ring.classList.add('hovering');
      } else {
        ring.classList.remove('hovering');
      }
    });
  })();

  /* ============================================================
     SCROLL PROGRESS + HEADER
  ============================================================ */
  (function initScroll() {
    var header = document.getElementById('headerV2');
    var progress = document.getElementById('scrollProgress');

    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY;
      var max = document.body.scrollHeight - window.innerHeight;

      if (header) {
        if (scrolled > 60) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }

      if (progress) {
        progress.style.transform = 'scaleX(' + (scrolled / max) + ')';
      }
    }, { passive: true });
  })();

  /* ============================================================
     REVEAL ON SCROLL
  ============================================================ */
  (function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      els.forEach(function (el) { obs.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('visible'); });
    }
  })();

  /* ============================================================
     MOBILE NAV
  ============================================================ */
  (function initMobileNav() {
    var burger = document.getElementById('hamburger');
    var nav = document.getElementById('mobileNav');
    if (!burger || !nav) return;

    burger.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('open');
      burger.classList.toggle('open', isOpen);
      burger.setAttribute('aria-expanded', isOpen);
      nav.setAttribute('aria-hidden', !isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        nav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  })();

  /* ============================================================
     CART DRAWER
  ============================================================ */
  (function initCart() {
    var toggle = document.getElementById('cartToggle');
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    var closeBtn = document.getElementById('cartClose');
    var body = document.getElementById('cartBody');
    var footer = document.getElementById('cartFooter');
    var countBadge = document.getElementById('cartCount');

    if (!toggle || !drawer) return;

    function openCart() {
      loadCart();
      drawer.classList.add('open');
      overlay.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
    closeBtn && closeBtn.addEventListener('click', closeCart);
    overlay && overlay.addEventListener('click', closeCart);

    function loadCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); })
        .catch(function () {
          if (body) body.innerHTML = '<p style="color:var(--ash);padding:24px;">Impossible de charger le panier.</p>';
        });
    }

    function renderCart(cart) {
      if (!body || !footer) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<div style="text-align:center;padding:64px 24px;"><p style="font-family:var(--font-display);font-size:24px;color:var(--parchment);margin-bottom:12px;">Votre panier est vide</p><p style="font-family:var(--font-ui);font-size:14px;color:var(--ash);">Découvrez nos éditions photo</p></div>';
        footer.innerHTML = '';
        return;
      }

      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="cart-item-v2">';
        if (item.image) {
          html += '<img class="cart-item-img" src="' + item.image + '" alt="' + escHtml(item.title) + '">';
        }
        html += '<div class="cart-item-info">';
        html += '<p class="cart-item-name">' + escHtml(item.title) + '</p>';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          html += '<p class="cart-item-variant">' + escHtml(item.variant_title) + '</p>';
        }
        html += '<div class="cart-item-actions">';
        html += '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>';
        html += '<span class="qty-display">' + item.quantity + '</span>';
        html += '<button class="qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>';
        html += '</div></div>';
        html += '<span class="cart-item-price">' + formatMoney(item.line_price) + '</span>';
        html += '</div>';
      });
      body.innerHTML = html;

      footer.innerHTML =
        '<div class="cart-total-row"><span class="cart-total-label">Total</span><span class="cart-total-amount">' + formatMoney(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="cart-checkout-btn">Passer commande <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></a>';

      // Update badge
      updateBadge(cart.item_count);

      // Qty buttons
      body.querySelectorAll('.qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = this.dataset.key;
          var qty = parseInt(this.dataset.qty);
          updateCartItem(key, qty);
        });
      });
    }

    function updateCartItem(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); });
    }

    function updateBadge(count) {
      if (!countBadge) return;
      countBadge.textContent = count;
      countBadge.classList.toggle('has-items', count > 0);
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }

    function escHtml(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // Listen for add-to-cart events
    document.addEventListener('obsess:cart:updated', function () { loadCart(); });
  })();

  /* ============================================================
     PRODUCT PAGE
  ============================================================ */
  (function initProduct() {
    /* Gallery */
    var thumbs = document.querySelectorAll('.gallery-thumb-v2');
    var slides = document.querySelectorAll('.gallery-slide-v2');

    if (thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(this.dataset.thumb);
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          slides.forEach(function (s) { s.classList.remove('active'); });
          this.classList.add('active');
          if (slides[idx]) slides[idx].classList.add('active');
        });
      });
    }

    /* Upload photo */
    var uploadInput = document.getElementById('photoUploadV2');
    var uploadZone = document.getElementById('uploadZoneV2');
    var preview = document.getElementById('uploadPreviewV2');
    var previewImg = document.getElementById('previewImgV2');
    var removeBtn = document.getElementById('removeUploadV2');

    if (uploadInput) {
      uploadInput.addEventListener('change', function () {
        var file = this.files[0];
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function (e) {
          if (previewImg) previewImg.src = e.target.result;
          if (preview) preview.style.display = 'block';
          if (uploadZone) uploadZone.style.display = 'none';
        };
        reader.readAsDataURL(file);
      });

      // Drag & drop
      if (uploadZone) {
        uploadZone.addEventListener('dragover', function (e) {
          e.preventDefault();
          this.classList.add('drag-over');
        });
        uploadZone.addEventListener('dragleave', function () {
          this.classList.remove('drag-over');
        });
        uploadZone.addEventListener('drop', function (e) {
          e.preventDefault();
          this.classList.remove('drag-over');
          var files = e.dataTransfer.files;
          if (files.length) {
            uploadInput.files = files;
            uploadInput.dispatchEvent(new Event('change'));
          }
        });
      }
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        if (uploadInput) uploadInput.value = '';
        if (preview) preview.style.display = 'none';
        if (uploadZone) uploadZone.style.display = 'block';
      });
    }

    /* Express toggle */
    var expressToggle = document.getElementById('expressToggle');
    var expressCheckbox = document.getElementById('expressCheckbox');
    var variantId = document.getElementById('variantId');
    var priceDisplay = document.getElementById('addToCartPrice');

    if (expressToggle && window.productDataV2) {
      var variants = window.productDataV2.variants;
      var isExpress = false;

      expressToggle.addEventListener('click', function () {
        isExpress = !isExpress;
        expressCheckbox && expressCheckbox.classList.toggle('checked', isExpress);
        var variant = isExpress ? variants[1] : variants[0];
        if (variant && variantId) {
          variantId.value = variant.id;
          if (priceDisplay) priceDisplay.textContent = '— ' + formatMoney(variant.price);
        }
      });

      expressToggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }

    /* Accordion product details */
    document.querySelectorAll('.accordion-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.accordion-item');
        item.classList.toggle('open');
      });
    });

    /* Add to cart form */
    var form = document.getElementById('productFormV2');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = document.getElementById('addToCartV2');
        if (btn) { btn.style.opacity = '0.7'; btn.disabled = true; }

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('obsess:cart:updated'));
            // Open cart drawer
            var cartDrawer = document.getElementById('cartDrawer');
            var cartOverlay = document.getElementById('cartOverlay');
            if (cartDrawer) {
              cartDrawer.classList.add('open');
              if (cartOverlay) cartOverlay.classList.add('open');
              cartDrawer.setAttribute('aria-hidden', 'false');
              document.body.style.overflow = 'hidden';
            }
            if (btn) { btn.style.opacity = ''; btn.disabled = false; }
          })
          .catch(function (err) {
            console.error('Add to cart error:', err);
            if (btn) { btn.style.opacity = ''; btn.disabled = false; }
          });
      });
    }

    /* Zoom gallery */
    var zoomBtn = document.getElementById('galleryZoomBtn');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var activeSlide = document.querySelector('.gallery-slide-v2.active img');
        if (activeSlide) {
          var lightbox = document.getElementById('lightbox');
          var lbImg = document.getElementById('lightboxImg');
          if (lightbox && lbImg) {
            lbImg.src = activeSlide.src;
            lbImg.style.display = 'block';
            var lbVid = document.getElementById('lightboxVideo');
            if (lbVid) lbVid.style.display = 'none';
            lightbox.classList.add('open');
            document.body.style.overflow = 'hidden';
          }
        }
      });
    }
  })();

  /* ============================================================
     HERO IMAGE LOADED
  ============================================================ */
  (function initHeroImage() {
    var heroImg = document.querySelector('.hero-bg-image');
    if (!heroImg) return;
    if (heroImg.complete) {
      heroImg.classList.add('loaded');
    } else {
      heroImg.addEventListener('load', function () { this.classList.add('loaded'); });
    }
  })();

  /* ============================================================
     HERO REVEAL
  ============================================================ */
  (function initHeroReveal() {
    var heroReveals = document.querySelectorAll('.hero-cinema .reveal');
    setTimeout(function () {
      heroReveals.forEach(function (el) { el.classList.add('visible'); });
    }, 1400);
  })();

  /* ============================================================
     MODALE FORMULAIRE PHOTO — Checkout
  ============================================================ */
  (function initPhotoModal() {
    var modal = document.getElementById('photoModal');
    var overlay = document.getElementById('photoModalOverlay');
    var closeBtn = document.getElementById('photoModalClose');
    var form = document.getElementById('photoModalForm');
    
    if (!modal || !overlay) return;
    
    function openPhotoModal() {
      modal.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      var emailField = document.getElementById('modalEmail');
      if (emailField) emailField.focus();
    }
    
    function closePhotoModal() {
      modal.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
    
    if (closeBtn) closeBtn.addEventListener('click', closePhotoModal);
    overlay.addEventListener('click', closePhotoModal);
    
    // Echap pour fermer
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) {
        closePhotoModal();
      }
    });
    
    // Intercepter le clic sur "Passer commande" dans le cart drawer ou n'importe quel lien checkout
    document.addEventListener('click', function(e) {
      var checkoutLink = e.target.closest('a[href="/checkout"], a[href*="/checkouts/"], .cart-checkout-btn');
      if (checkoutLink) {
        e.preventDefault();
        e.stopPropagation();
        openPhotoModal();
      }
    });
    
    // Soumettre le formulaire modale
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        var email = document.getElementById('modalEmail').value;
        var photoLink = document.getElementById('modalPhotoLink').value;
        var instructions = document.getElementById('modalInstructions').value;
        
        if (!email) {
          alert('Veuillez renseigner votre email');
          document.getElementById('modalEmail').focus();
          return;
        }
        
        // Sauvegarder les infos dans le panier via note attributes
        var submitBtn = document.getElementById('photoModalSubmit');
        if (submitBtn) {
          submitBtn.style.opacity = '0.7';
          submitBtn.disabled = true;
        }
        
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Email contact': email,
              'Lien photo': photoLink || 'Envoi par email apres commande',
              'Instructions': instructions || 'Aucune instruction particuliere'
            }
          })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          // Rediriger vers le checkout
          window.location.href = '/checkout';
        })
        .catch(function(err) {
          if (submitBtn) {
            submitBtn.style.opacity = '';
            submitBtn.disabled = false;
          }
          alert('Erreur, veuillez reessayer');
        });
      });
    }
    
    // Exposer la fonction pour l'ouvrir manuellement si besoin
    window.openPhotoModal = openPhotoModal;
    window.closePhotoModal = closePhotoModal;
  })();

})();
